const app = {
  state: {
    language: localStorage.getItem("rnd-language") || "de",
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      localStorage.setItem("rnd-language", language);
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
  },
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js